import { workshopAr, workshopEn } from './workshopMessages';

const en = {
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'common.confirm': 'Confirm',
  'common.working': 'Working…',
  'common.loading': 'Loading…',
  'common.search': 'Search',
  'common.empty': 'Nothing here yet.',
  'common.signOut': 'Sign out',
  'common.administrator': 'Administrator',
  'common.english': 'English',
  'common.arabic': 'Arabic',
  'common.language': 'Language',
  'common.required': 'Required',
  'common.optional': 'Optional',
  'common.unnamed': 'Unnamed',
  'common.vehicle': 'Vehicle',
  'common.service': 'Service',
  'common.visit': 'Visit',
  'common.booking': 'Booking',

  'nav.floor': 'Today',
  'nav.bookings': 'Jobs',
  'nav.customers': 'Customers',
  'nav.services': 'Services',
  'nav.finances': 'Finances',
  'nav.reviews': 'Reviews',
  'nav.resale': 'Pre-purchase checks',
  'nav.mechanicActivity': 'Team activity',
  'nav.management': 'Settings',

  'layout.workshop': 'Workshop',
  'layout.serviceDesk': 'Workshop desk',

  'login.kicker': 'Workshop',
  'login.title': 'Sign in',
  'login.lede': 'Sign in with your staff account to open the service desk.',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.submitting': 'Signing in…',
  'login.notStaff': 'This desk is for workshop staff. Your account is a customer profile',
  'login.loading': 'Loading…',

  'status.pending': 'Pending',
  'status.confirmed': 'Confirmed',
  'status.checked_in': 'Checked in',
  'status.in_progress': 'In the bay',
  'status.completed': 'Completed',
  'status.cancelled': 'Cancelled',

  'floor.kicker': 'Live',
  'floor.title': 'Floor',
  'floor.lede': "Today's live floor at a glance. Open any visit to move it forward.",
  'floor.allBookings': 'All bookings',
  'floor.customers': 'Customers',
  'floor.bookings': 'Bookings',
  'floor.menu': 'Menu',
  'floor.cars': 'Cars',
  'floor.empty': 'Empty',
  'floor.late': 'Late',
  'floor.awaitingCustomer': 'Awaiting customer',

  'bookings.kicker': 'Diary',
  'bookings.title': 'Bookings',
  'bookings.lede': 'Every visit in one place. Filter, search, or drag cards on the board.',
  'bookings.all': 'All',
  'bookings.today': 'Today',
  'bookings.upcoming': 'Upcoming',
  'bookings.past': 'Past',
  'bookings.range': 'Range',
  'bookings.branch': 'Branch',
  'bookings.file': 'file',
  'bookings.files': 'files',
  'bookings.late': 'Late',
  'bookings.awaitingCustomer': 'Awaiting customer',

  'visit.workshopSteps': 'Workshop steps',
  'visit.workshopLede': 'First inspect, then log parts and work, then send the quotation.',
  'visit.resaleTitle': 'Pre-purchase inspection',
  'visit.resaleLede': 'Check in, complete the certified report, and publish the buyer link from the Resale desk.',
  'visit.stepInspection': 'Inspection',
  'visit.stepInspectionLede': 'Mileage, photos, diagnostics, and health scores.',
  'visit.stepWork': 'Parts & work log',
  'visit.stepWorkLede': 'Record parts, fluids, and work done — these feed the quotation.',
  'visit.stepQuote': 'Quotation',
  'visit.stepQuoteLede': 'Review auto-filled charges, set prices, then send to the customer.',
  'visit.awaitingReply': 'Awaiting customer reply',
  'visit.anyMechanic': 'Any available',
  'visit.done': 'Done',
  'visit.now': 'Now',
  'visit.next': 'Next',
  'visit.checkInUnlock': 'Check the car in to unlock inspection, work log, and quotation.',

  'hours.day.1': 'Monday',
  'hours.day.2': 'Tuesday',
  'hours.day.3': 'Wednesday',
  'hours.day.4': 'Thursday',
  'hours.day.5': 'Friday',
  'hours.day.6': 'Saturday',
  'hours.day.7': 'Sunday',

  'customers.kicker': 'People',
  'customers.title': 'Customers',
  'customers.lede': 'Search the directory, then open a customer for registration details, garage, and visits.',
  'customers.search': 'Name, phone, email, plate…',
  'customers.sheetSubtitle': 'Registration & garage',
  'customers.loading': 'Loading customers…',
  'customers.none': 'No customers match.',
  'customers.showing': 'Showing {from}–{to} of {total}',
  'customers.clearSearch': 'Clear search',
  'customers.joined': 'Joined {when}',
  'customers.noCarsListed': 'No cars on file',
  'customers.colCustomer': 'Customer',
  'customers.colContact': 'Contact',
  'customers.colGarage': 'Garage',
  'customers.colJoined': 'Joined',
  'customers.pagination': 'Customer pages',
  'customers.prev': 'Previous',
  'customers.next': 'Next',
  'customers.pageOf': 'Page {page} of {pages}',

  'services.kicker': 'Catalog',
  'services.title': 'Services',
  'services.lede': 'Services customers see in the app. Enter English and Arabic — the app shows the language each customer chose.',
  'services.new': 'New service',
  'services.edit': 'Edit service',
  'services.sheetSubtitle': 'Service menu',
  'services.viewOnly': 'View only — a manager account can add or edit the menu.',
  'services.noDescription': 'No description',
  'services.featured': 'Featured',
  'services.removeConfirm': 'Remove this service from the app menu?',
  'services.remove': 'Remove',
  'services.nameEn': 'Name (English)',
  'services.nameAr': 'Name (Arabic)',
  'services.descriptionEn': 'Description (English)',
  'services.descriptionAr': 'Description (Arabic)',
  'services.durationEn': 'Duration label (English)',
  'services.durationAr': 'Duration label (Arabic)',
  'services.durationHintEn': '45 min, Half day, By quote',
  'services.durationHintAr': '٤٥ دقيقة، نصف يوم، حسب العرض',
  'services.price': 'Price (EGP)',
  'services.minutes': 'Est. minutes',
  'services.icon': 'Icon',
  'services.sort': 'Sort',
  'services.visible': 'Visible in the app',
  'services.featuredCheck': 'Featured on the services screen',
  'services.langEn': 'English',
  'services.langAr': 'Arabic',
  'services.needBothNames': 'Add the name in English and Arabic.',
  'services.needBothDescriptions': 'Add the description in English and Arabic.',
  'services.needBothDurations': 'Add the duration label in English and Arabic.',

  'finances.kicker': 'Finance',
  'finances.title': 'Quotations',
  'finances.lede': 'Create quotations for open visits, or as standalone estimates for walk-ins.',
  'finances.create': 'Create quotation',

  'reviews.kicker': 'Quality',
  'reviews.title': 'Verified reviews',
  'reviews.lede': 'Customers can only review after a completed visit. Managers get automatic alerts when any score falls at or below the threshold you set.',
  'reviews.count': 'Reviews',
  'reviews.avg': 'Avg overall',
  'reviews.below': 'Below threshold',
  'reviews.alerts': 'Low-rating alerts',

  'resale.kicker': 'Certified pre-purchase',
  'resale.title': 'Resale inspections',
  'resale.lede': 'Incoming seller bookings, walk-in drafts, and finalized buyer reports — all in one workflow.',
  'resale.walkIn': 'Walk-in inspection',
  'resale.search': 'Search plate, VIN, seller, report #',

  'alerts.kicker': 'Broadcast',
  'alerts.title': 'Alerts',
  'alerts.lede': 'One notice to every app user — inbox and lock screen.',
  'alerts.sent': 'sent',
  'alerts.compose': 'Compose',
  'alerts.composeHint': 'Keep it short. This is what lands on the phone.',
  'alerts.managersOnly': 'Only a manager account can send alerts.',

  'mechanic.kicker': 'Mechanics',
  'mechanic.title': 'Mechanic activity',
  'mechanic.lede': 'Search and filter your team, then open a mechanic to review their work history in detail.',
  'mechanic.allActivity': 'All activity',
  'mechanic.add': 'Add mechanic',
  'mechanic.mechanics': 'Mechanics',
  'mechanic.withActivity': 'With activity',

  'setup.kicker': 'Setup',
  'setup.title': 'Workshop settings',
  'setup.lede': 'Configure hours, locations, brands, and team access — one focused screen at a time.',
  'setup.locations': 'Locations',
  'setup.locationsCopy': 'Names, addresses, and map links customers see in the app.',
  'setup.hours': 'Hours & bays',
  'setup.hoursCopy': 'Opening times, slot length, and how many cars can overlap.',
  'setup.brands': 'Car brands',
  'setup.brandsCopy': 'Which makes and years customers can add to their garage.',
  'setup.team': 'Team',
  'setup.teamCopy': 'Who can sign in — admins, service advisors, and mechanics.',
  'setup.business': 'Business info',
  'setup.businessCopy': 'Branding, contact details, and logo used in PDFs and contact screens.',
  'setup.back': 'Setup',
  'setup.locationsLede': 'Branches in the customer app. Hours and bays are next door, under Hours & bays.',
  'setup.brandsLede': 'Makes and years the app offers when a customer adds a car.',
  'setup.teamLede': 'People who can open this desk.',
  'setup.admins': 'Admins',
  'setup.adminsLede': 'Managers run setup. Service advisors only see the desk tabs you give them.',
  'setup.mechanics': 'Mechanics',
  'setup.addAdmin': 'Add admin',
  'setup.noAdmins': 'No admins yet.',
  'setup.noMechanics': 'No mechanics yet. Bookings still work without them.',
  'setup.hoursLede': 'Pick a location. Set when it is open, slot length, and how many cars can overlap.',
  'setup.branch': 'Branch',
  'setup.businessTitle': 'Business info',

  'team.name': 'Name',
  'team.phone': 'Phone',
  'team.role': 'Role',
  'team.branch': 'Branch',
  'team.tabs': 'Tabs',
  'team.tabsAll': 'All',
  'team.tabsCount': '{n} of {total}',
  'team.unassigned': 'Unassigned',
  'team.chooseTabs': 'Choose visible tabs',
  'team.chooseTabsFor': 'Choose tabs for {name}',
  'team.tabsTitle': 'Tabs · {name}',
  'team.access': 'Access',
  'team.mechanicTabsLede': 'Choose which console tabs this mechanic can open. At least one is required.',
  'team.advisorTabsLede': 'Choose which console tabs this service advisor can open. At least one is required.',
  'team.createTabsLede': 'They will only see the tabs you select. At least one is required.',
  'team.deskTabs': 'Desk tabs',
  'team.selectAll': 'Select all',
  'team.floorBookings': 'Floor + bookings',
  'team.exceptSetup': 'All except setup',
  'team.saveAccess': 'Save access',
  'team.pickOneTab': 'Pick at least one tab.',
  'team.assignBranch': 'Assign a branch first.',
  'team.createLogin': 'Create login',
  'team.creating': 'Creating…',
  'team.createLede': 'They can sign in with this email and password.',
  'team.firstName': 'First name',
  'team.lastName': 'Last name',
  'team.email': 'Email',
  'team.tempPassword': 'Temporary password',
  'team.resetPassword': 'Reset password',
  'team.resetPasswordFor': 'Reset password · {name}',
  'team.newPassword': 'New password',
  'team.passwordHint': 'At least 8 characters. They will use this the next time they sign in.',
  'team.resetting': 'Resetting…',
  'team.resetOk': 'Password updated.',
  'team.passwordMin': 'Password must be at least 8 characters.',

  'role.manager': 'Admin',
  'role.advisor': 'Service Advisor',

  'reception.title': 'Smart vehicle reception',
  'reception.lede': 'Digital check-in: mileage, VIN, photos, damage map, and customer signature.',
  'reception.complete': 'Complete',
  'reception.draft': 'In progress',
  'reception.locked': 'Reception is submitted and locked. It cannot be edited.',
  'reception.mileage': 'Mileage (km)',
  'reception.fuel': 'Fuel level',
  'reception.pickFuel': 'Select fuel level',
  'reception.fuel.empty': 'Empty',
  'reception.fuel.1/4': '1/4',
  'reception.fuel.1/2': '1/2',
  'reception.fuel.3/4': '3/4',
  'reception.fuel.full': 'Full',
  'reception.vin': 'VIN',
  'reception.vinPlaceholder': 'Scan or type chassis number',
  'reception.vinUnavailable': 'VIN not available',
  'reception.photos': 'Vehicle photos',
  'reception.photosLede': 'Front, rear, left, and right are required.',
  'reception.addPhoto': 'Add photo',
  'reception.takePhoto': 'Take photo',
  'reception.uploadPhoto': 'Upload image',
  'reception.side.front': 'Front',
  'reception.side.rear': 'Rear',
  'reception.side.left': 'Left',
  'reception.side.right': 'Right',
  'reception.side.roof': 'Roof',
  'reception.side.interior': 'Interior',
  'reception.bodyType': 'Body type',
  'reception.body.sedan': 'Sedan',
  'reception.body.hatch': 'Hatchback',
  'reception.body.suv': 'SUV',
  'reception.body.coupe': 'Coupe',
  'reception.body.pickup': 'Pickup',
  'reception.body.van': 'Van',
  'reception.noDamage': 'No visible damage',
  'reception.tapDamage': 'Tap to mark scratches or dents',
  'reception.damageMark': 'Damage mark',
  'reception.clearMarks': 'Clear all marks',
  'reception.undoMark': 'Undo last mark',
  'reception.accessories': 'Accessories inside',
  'reception.accessoriesPlaceholder': 'Phone mount, child seat, sunglasses… or “None”',
  'reception.warningLights': 'Dashboard warning lights',
  'reception.warningPlaceholder': 'None, check engine, ABS…',
  'reception.signature': 'Customer signature',
  'reception.signatureLede': 'Customer signs to confirm the vehicle condition at drop-off.',
  'reception.signatureOnFile': 'Signature on file.',
  'reception.captureSignature': 'Capture signature',
  'reception.resign': 'Re-sign',
  'reception.signatureReady': 'Signature captured',
  'reception.done': 'Done',
  'reception.clearSignature': 'Clear signature',
  'reception.saveDraft': 'Save draft',
  'reception.finalize': 'Complete check-in',
  'reception.saved': 'Reception draft saved.',
  'reception.finalized': 'Vehicle received. Booking is checked in.',
  'reception.completedHint': 'Reception is on file for this visit.',
  'reception.start': 'Start check-in',
  'reception.continue': 'Continue check-in',
  'reception.view': 'View check-in',
  'reception.appOnly': 'Complete check-in in the Service Advisor app when the car arrives.',
  'reception.appOnlyTitle': 'Vehicle check-in',
  'reception.openVisit': 'Open check-in',
  'reception.checkIns': 'Check-ins',
  'reception.checkInsEmpty': 'No check-ins for this car yet.',
  'reception.errMileage': 'Enter the current mileage.',
  'reception.errFuel': 'Select a fuel level.',
  'reception.errBodyType': 'Choose a body type.',
  'reception.errDamage': 'Mark damage on the diagram or confirm no damage.',
  'reception.errVin': 'Enter the VIN or mark it unavailable.',
  'reception.errSignature': 'Customer signature is required.',
  'reception.errPhoto.front': 'Front photo is required.',
  'reception.errPhoto.rear': 'Rear photo is required.',
  'reception.errPhoto.left': 'Left photo is required.',
  'reception.errPhoto.right': 'Right photo is required.',
  'reception.errAuth': 'Sign in again to upload.',
  'reception.errSave': 'Could not save reception.',
  'role.technician': 'Mechanic',
  'role.customer': 'Customer',

  'icon.handyman': 'General',
  'icon.car': 'Car',
  'icon.periodic': 'Periodic',
  'icon.inspection': 'Inspection',
  'icon.diagnostics': 'Diagnostics',
  'icon.engine': 'Engine',
  'icon.oil': 'Oil',
  'icon.filter': 'Filter',
  'icon.coolant': 'Coolant',
  'icon.fuel': 'Fuel',
  'icon.battery': 'Battery',
  'icon.electrical': 'Electrical',
  'icon.spark': 'Ignition',
  'icon.brakes': 'Brakes',
  'icon.tyres': 'Tyres',
  'icon.alignment': 'Alignment',
  'icon.suspension': 'Suspension',
  'icon.transmission': 'Gearbox',
  'icon.clutch': 'Clutch',
  'icon.exhaust': 'Exhaust',
  'icon.ac': 'A/C',
  'icon.hvac': 'Climate',
  'icon.radiator': 'Radiator',
  'icon.lights': 'Lights',
  'icon.glass': 'Glass',
  'icon.body': 'Body',
  'icon.dent': 'Dent / crash',
  'icon.paint': 'Paint',
  'icon.polish': 'Polish',
  'icon.wash': 'Wash',
  'icon.detailing': 'Detailing',
  'icon.interior': 'Interior',
  'icon.audio': 'Audio',
  'icon.keys': 'Keys',
  'icon.warranty': 'Warranty',
  'icon.shield': 'Cover',
  'icon.ev': 'EV',
  'icon.charging': 'Charging',
  'icon.towing': 'Towing',
  'icon.pickup': 'Pickup',
  'icon.fleet': 'Fleet',
  'icon.motorcycle': 'Motorcycle',
  'icon.emergency': 'Emergency',
  'icon.quote': 'Quote',
  'icon.welding': 'Welding',
  'icon.tools': 'Tools',
  'icon.engineering': 'Workshop',
  'icon.health': 'Safety',

  'journey.group.intake': 'Intake',
  'journey.group.estimate': 'Estimate',
  'journey.group.repair': 'Repair',
  'journey.group.finish': 'Finish',
  'journey.vehicle_received': 'Vehicle received',
  'journey.initial_inspection': 'Initial inspection',
  'journey.computer_diagnosis': 'Computer diagnosis',
  'journey.quotation_prepared': 'Quotation prepared',
  'journey.awaiting_customer_approval': 'Awaiting approval',
  'journey.spare_parts_requested': 'Spare parts requested',
  'journey.repair_in_progress': 'Repair in progress',
  'journey.quality_inspection': 'Quality inspection',
  'journey.car_wash': 'Car wash',
  'journey.ready_for_collection': 'Ready for collection',

  'stay.wait': 'Wait at centre',
  'stay.leave': 'Leave the car',
  'stay.pickup': 'Pickup / delivery',
  'stay.minutes': '{n} min',

  'visit.liveJourney': 'Live journey',
  'visit.scheduling': 'Scheduling',
  'visit.customerCar': 'Customer & car',
  'visit.managedResale': 'Managed in the Resale tab',
  'visit.resaleOpen': 'Open Resale desk',
  'visit.finalizeBefore': 'Finalize inspection before repair stages.',
  'visit.adminSkip': 'Administrator: tap any upcoming stage to skip ahead.',
  'visit.mark': 'Mark {name}',
  'visit.skipTo': 'Skip to {name}',
  'visit.cancelVisit': 'Cancel visit',
  'visit.jumpStatus': 'Jump to status',
  'visit.moreStatus': 'More status options',
  'visit.nextConfirm': 'Confirm booking',
  'visit.nextAssign': 'Assign mechanic',
  'visit.nextWaitingCheckIn': 'Complete check-in in the Service Advisor app.',
  'visit.nextWaitingHealth': 'Waiting for health inspection in the bay.',
  'visit.nextReadyBay': 'Ready for the mechanic to start work.',
  'visit.nextComplete': 'Mark completed',
  'visit.pillNeedsConfirmation': 'Needs confirmation',
  'visit.pillNeedsCheckIn': 'Needs check-in',
  'visit.pillNeedsMechanic': 'Needs mechanic',
  'visit.pillReadyBay': 'Ready for bay',
  'visit.pillInProgress': 'In progress',
  'visit.pillDone': 'Done',
  'visit.pillCancelled': 'Cancelled',
  'visit.detailsSubtitle': 'Visit reference',
  'visit.when': 'When',
  'visit.stay': 'Stay',
  'visit.preferredMechanic': 'Preferred mechanic',
  'visit.pickupNotes': 'Pickup notes',
  'visit.fromCustomer': 'From customer',
  'visit.cancelReason': 'Cancel reason',
  'visit.opened': 'Opened',
  'visit.customer': 'Customer',
  'visit.phone': 'Phone',
  'visit.plate': 'Plate',
  'visit.booked': 'Booked',
  'visit.ready': 'Ready',
  'visit.needHealth': 'Finalize the vehicle health report before starting work.',
  'visit.needReception': 'Waiting for Service Advisor check-in.',
  'visit.nextStartWork': 'Start work',

  'bookings.list': 'List',
  'bookings.kanban': 'Board',
  'bookings.from': 'From',
  'bookings.to': 'To',
  'bookings.customer': 'Customer',
  'bookings.car': 'Car',
  'bookings.customerPlaceholder': 'Name, email, phone…',
  'bookings.carPlaceholder': 'Brand, model, year, plate…',
  'bookings.anyStatus': 'Any status',
  'bookings.noPlate': 'No plate',
  'bookings.cannotMove': 'You cannot move this booking directly.',
  'bookings.needHealth': 'Finalize the vehicle health report on the booking before starting work.',
  'bookings.needReception': 'Waiting for Service Advisor check-in on this booking.',
  'reception.badgeDone': 'Checked in',
  'reception.badgeNeeded': 'Needs check-in',
  'reception.viewPhoto': 'View',
  'bookings.updateFailed': 'Could not update booking.',
  'bookings.expand': 'Expand {name}',
  'bookings.collapse': 'Collapse {name}',

  'hours.applyAll': 'Apply this schedule to all branches',
  'hours.applyAllWarn': 'Saving will overwrite hours, slot length, and bays on every branch.',
  'hours.slots': 'Booking slots',
  'hours.slotsLede': 'Slot length is the diary grid. Each branch has at most two bays, so at most two jobs may overlap.',
  'hours.interval': 'Time interval (minutes)',
  'hours.bays': 'Parallel bays',
  'hours.opening': 'Opening hours',
  'hours.openingLede': 'Days and times customers can book at {place}.',
  'hours.everyBranch': 'every branch',
  'hours.thisBranch': 'this branch',
  'hours.dayCol': 'Day',
  'hours.opens': 'Opens',
  'hours.closes': 'Closes',
  'hours.closed': 'Closed',
  'hours.saveBranch': 'Save this branch',
  'hours.saveAll': 'Save for all {n} branches',

  'setup.open': 'Open',
  'setup.saved': 'Business info saved.',
  'setup.loadingBusiness': 'Loading business info…',
  'setup.brandName': 'Brand name',
  'setup.legalName': 'Legal name',
  'setup.tagline': 'Tagline',
  'setup.address': 'Address',
  'setup.phonePrimary': 'Primary phone',
  'setup.phoneSecondary': 'Secondary phone',
  'setup.supportEmail': 'Support email',
  'setup.website': 'Website',
  'setup.logoUrl': 'Logo URL',
  'setup.saveBusiness': 'Save business info',
  'setup.addLocation': 'Add location',
  'setup.noLocations': 'No locations yet.',
  'setup.noAddress': 'No address',
  'setup.phone': 'Phone',
  'setup.openMap': 'Open map',
  'setup.setHours': 'Set hours & bays',
  'setup.removeLocation': 'Remove this location? Bookings tied to it will block delete.',
  'setup.editLocation': 'Edit location',
  'setup.newLocation': 'New location',
  'setup.name': 'Name',
  'setup.mapLink': 'Map link',
  'setup.mapHint': 'Paste the Google Maps share URL. Customers tap Open in maps in the app.',
  'setup.loadFailed': 'Could not load business info.',

  'assign.label': 'Assigned mechanic',
  'assign.unassigned': 'Unassigned',
  'assign.empty': 'No mechanics at this branch yet. Add them under Settings → Team.',
  'assign.saved': 'Mechanic assignment saved.',
  'assign.failed': 'Could not assign mechanic.',

  'qc.title': 'Mechanic QC',
  'qc.approve': 'Approve',
  'qc.reject': 'Reject',
  'qc.waiting': 'A mechanic is waiting for QC sign-off on this visit.',
  'qc.approvedNote': 'Approved from desk',
  'qc.needsWork': 'Needs more work',

  'reschedule.title': 'Reschedule visit',
  'reschedule.current': 'Current: {when}',
  'reschedule.day': 'Day',
  'reschedule.loading': 'Loading available slots…',
  'reschedule.empty': 'No open slots on this day.',
  'reschedule.slots': 'Available time slots',
  'reschedule.save': 'Save new time',
  'reschedule.loadFailed': 'Could not load time slots.',

  'quote.title': 'Quotation',
  'quote.titleInspection': 'Pre-sale inspection quotation',
  'quote.titleRepair': 'Repair quotation',
  'quote.lede': 'Log parts and work first, then build the quote here. Lines from the work log and inspection are added automatically.',
  'quote.ledeInspection': 'Bill the seller for the certified pre-purchase inspection. Price is pulled from your catalog — adjust before sending.',
  'quote.ledeRepair': 'Optional priced quote for recommended repairs found during the inspection.',
  'quote.ledeClosed': 'Quotation from this visit. Export or share the PDF if you need a copy.',
  'quote.ledeClosedEmpty': 'This visit is closed. No quotation was sent.',
  'quote.emptyClosed': 'No quotation on this visit.',
  'quote.emptyOpen': 'Nothing sent yet.',
  'quote.replace': 'This replaces the quote the customer already has.',
  'quote.revise': 'Revise the rejected lines and send again. Approval starts over.',
  'quote.item': 'Item',
  'quote.qty': 'Qty',
  'quote.unitPrice': 'Unit price',
  'quote.line': 'Line',
  'quote.addLine': 'Add line',
  'quote.addLabour': 'Add labour',
  'quote.labour': 'Labour',
  'quote.total': 'Total',
  'quote.workLog': 'Work log',
  'quote.inspection': 'Inspection',
  'quote.sendCustomer': 'Send to customer',
  'quote.sendSeller': 'Send to seller',
  'quote.update': 'Update quotation',
  'quote.sendRevised': 'Send revised quotation',
  'quote.syncWorkLog': 'Sync from work log',
  'quote.refreshCatalog': 'Refresh from catalog',
  'quote.importInspection': 'Import from inspection',
  'quote.notePlaceholder': 'Pads are worn. Labour is included.',
  'quote.itemPlaceholder': 'Brake pads, labour, oil…',
  'quote.catalogLine': 'Inspection service line from your catalog — adjust the price if needed.',
  'quote.shared': 'Quotation shared.',
  'quote.downloaded': 'Sharing is not available in this browser. Downloaded the PDF instead.',

  'worklog.kicker': 'Passport',
  'worklog.title': 'Work log',
  'worklog.lede': 'Record oil, battery, tires, and spare parts for this visit. Details appear on the vehicle maintenance passport.',
  'worklog.opening': 'Opening job card…',
  'worklog.category': 'Category',
  'worklog.date': 'Install / service date',
  'worklog.oilSpec': 'Oil type / spec',
  'worklog.quantity': 'Quantity',
  'worklog.unit': 'Unit',
  'worklog.liters': 'Liters',
  'worklog.quarts': 'Quarts',
  'worklog.event': 'Event',
  'worklog.position': 'Position',
  'worklog.name': 'Name / part',
  'worklog.partNumber': 'Part number',
  'worklog.supplier': 'Supplier',
  'worklog.serial': 'Serial / batch',
  'worklog.notes': 'Notes',
  'worklog.add': 'Add to work log',
  'worklog.added': 'Added to work log.',
  'worklog.photo': 'Add package photo',
  'worklog.uploading': 'Uploading…',
  'worklog.photoAttached': 'Photo attached',
  'worklog.cat.oil': 'Oil & filter',
  'worklog.cat.battery': 'Battery',
  'worklog.cat.tire': 'Tires',
  'worklog.cat.spare': 'Spare part',
  'worklog.cat.other': 'Other',
  'worklog.event.replace': 'Replace',
  'worklog.event.rotate': 'Rotate',
  'worklog.event.top_up': 'Top up',
  'worklog.event.inspect': 'Inspect',
  'worklog.pos.FL': 'Front left',
  'worklog.pos.FR': 'Front right',
  'worklog.pos.RL': 'Rear left',
  'worklog.pos.RR': 'Rear right',
  'worklog.pos.all': 'All tires',

  'health.title': 'Vehicle health inspection',
  'health.ledeOpen': 'Start from the car’s saved details, tap suggestions to fill faster, then finalize before moving into the bay.',
  'health.ledeDone': 'Inspection submitted. Review scores below, export a PDF, or edit if something needs updating.',
  'health.loading': 'Loading health inspection…',
  'health.afterCheckin': 'Health inspection is available after the vehicle is checked in.',
  'health.savedMileage': 'Saved mileage',
  'health.notSet': 'Not set yet',
  'health.progress': '{n} of 5 required items complete',
  'health.ready': 'Ready',
  'health.required': 'Required',
  'health.mileage': 'Current mileage',
  'health.mileageHelp': 'Prefilled from the customer’s garage. Update it if the odometer reading is higher.',
  'health.odometer': 'Odometer (km)',
  'health.useSaved': 'Use saved {n} km',
  'health.services': 'Recent / due services',
  'health.diagnostics': 'Diagnostics',
  'health.accident': 'Accident history',
  'health.photos': 'Photos',
  'health.scores': 'Health scores',
  'health.finalize': 'Finalize',
  'health.finalizeTitle': 'Finalize health report?',
  'health.finalized': 'Health report finalized.',
  'health.draftSaved': 'Draft saved.',
  'health.good': 'Good',
  'health.fair': 'Fair',
  'health.poor': 'Poor',
  'health.goodHint': 'No issues found',
  'health.fairHint': 'Monitor / service soon',
  'health.poorHint': 'Needs attention',
  'health.overall': 'Overall',

  'customer.overview': 'Overview',
  'customer.health': 'Health',
  'customer.passport': 'Passport',
  'customer.engine': 'Engine',
  'customer.transmission': 'Transmission',
  'customer.mileage': 'Mileage',
  'customer.vin': 'VIN',
  'customer.warranty': 'Warranty',
  'customer.insurance': 'Insurance',
  'customer.open': 'Open',
  'customer.noVisitsCar': 'No visits for this car yet.',
  'customer.noVisits': 'No visits yet.',
  'customer.latestInspection': 'Latest inspection',
  'customer.earlierReports': 'Earlier reports',
  'customer.noHealth': 'No finalized health report yet.',
  'customer.noInspection': 'No inspection yet',
  'customer.lastChecked': 'Last checked {when}',
  'customer.download': 'Download',
  'customer.share': 'Share',
  'customer.preparing': 'Preparing…',
  'customer.noPhone': 'No phone on file',
  'customer.noPlate': 'No plate',
  'customer.cars': 'Cars',
  'customer.visits': 'Visits',
  'customer.registration': 'Registration',
  'customer.registrationLede': 'Details entered when this account was created.',
  'customer.garage': 'Garage & visits',
  'customer.garageLede': 'Vehicles on file and every service visit linked to this customer.',
  'customer.firstName': 'First name',
  'customer.lastName': 'Last name',
  'customer.email': 'Email',
  'customer.phone': 'Phone',
  'customer.memberSince': 'Member since',
  'customer.role': 'Role',
  'customer.call': 'Call',
  'customer.emailAction': 'Email',
  'customer.loading': 'Loading customer…',
  'customer.noCars': 'No cars on this account yet.',
  'customer.carOne': 'car',
  'customer.carsCount': 'cars',
  'customer.visitOne': 'visit',
  'customer.visitsCount': 'visits',

  'finances.connect': 'Connect to open visit',
  'finances.modeBooking': 'Open visit',
  'finances.modeStandalone': 'Walk-in / no visit',
  'finances.searchPlaceholder': 'Phone, email, customer, plate…',
  'finances.bookingDate': 'Booking date',
  'finances.bookingCount': '{n} open visits · newest first',
  'finances.bookingCountOne': '1 open visit · newest first',
  'finances.noMatch': 'No open visits match. Try another phone, email, or date.',
  'finances.selected': 'Selected: {service} on {when}',
  'finances.created': 'Quotation created and sent to customer.',
  'finances.createdStandalone': 'Quotation created. Publish a web link to share it.',
  'finances.exported': 'Quotation PDF exported.',
  'finances.shared': 'Quotation shared.',
  'finances.sharedFallback': 'Sharing is not supported here. Downloaded PDF instead.',
  'finances.needLines': 'Every line needs a quantity of at least 1 and a valid price.',
  'finances.needOneLine': 'Add at least one charge.',
  'finances.needBooking': 'Choose an open visit first.',
  'finances.standaloneCustomer': 'Customer (optional)',
  'finances.standaloneHint': 'Link a customer account, or leave empty for a walk-in estimate.',
  'finances.customerSearch': 'Search customer by name, phone, or email…',
  'finances.clearCustomer': 'Clear',
  'finances.noCustomerOk': 'No customer selected — you can still create and share the quote.',
  'finances.vehicleLabel': 'Vehicle (optional)',
  'finances.vehicleLabelPlaceholder': 'e.g. BMW 320i · ABC 1234',
  'finances.standaloneBadge': 'Standalone',
  'finances.noCustomer': 'No customer',
  'finances.listSearch': 'Search customer, service, plate…',
  'finances.allStatuses': 'All statuses',
  'finances.statusSent': 'Awaiting reply',
  'finances.statusApproved': 'Approved',
  'finances.statusPartial': 'Partial',
  'finances.statusRejected': 'Rejected',
  'finances.statusDraft': 'Draft',
  'finances.loading': 'Loading quotations…',
  'finances.none': 'No quotations in this view.',
  'finances.colQuote': 'Quote',
  'finances.colCustomer': 'Customer',
  'finances.colStatus': 'Status',
  'finances.colTotal': 'Total',
  'finances.linkLive': 'Link live',
  'finances.pagination': 'Quotation pages',
  'finances.createSubtitle': 'Open visit or walk-in estimate',
  'finances.sending': 'Sending…',
  'finances.createdAt': 'Created',
  'finances.visit': 'Visit',
  'finances.openVisit': 'Open visit',

  'reviews.notify': 'Notify managers when any dimension is at or below the selected level (1 = strict, 5 = off).',
  'reviews.threshold': 'Alert when any score is at or below',
  'reviews.sendAlerts': 'Send manager alerts',
  'reviews.verified': 'Verified',
  'reviews.lowScore': 'Low score',
  'reviews.overall': 'Overall',
  'reviews.advisor': 'Advisor',
  'reviews.mechanic': 'Mechanic',
  'reviews.speed': 'Speed',
  'reviews.price': 'Price clarity',
  'reviews.cleanliness': 'Cleanliness',
  'reviews.pickup': 'Pickup & delivery',

  'alerts.needEnglish': 'English title and message are required.',
  'alerts.sentOk': 'Sent. Phones with notifications on will get a push.',
  'alerts.titleLabel': 'Title',
  'alerts.message': 'Message',
  'alerts.arabicTitle': 'Arabic title',
  'alerts.arabicMessage': 'Arabic message',
  'alerts.optional': 'optional',
  'alerts.previewTitle': 'Title',
  'alerts.previewBody': 'The message customers will see.',

  'resale.emptyPending': 'No incoming inspections.',
  'resale.emptyConfirmed': 'No confirmed inspections yet.',
  'resale.deleteDraft': 'Could not delete draft.',

  'common.poweredBy': 'Powered by',
  'common.export': 'Export',
  'common.share': 'Share',
  'common.open': 'Open',
  'common.remove': 'Remove',
  'common.create': 'Create',
  'common.all': 'All',
};

const ar = {
  'common.save': 'حفظ',
  'common.saving': 'جارٍ الحفظ…',
  'common.cancel': 'إلغاء',
  'common.delete': 'حذف',
  'common.edit': 'تعديل',
  'common.back': 'رجوع',
  'common.confirm': 'تأكيد',
  'common.working': 'جارٍ العمل…',
  'common.loading': 'جارٍ التحميل…',
  'common.search': 'بحث',
  'common.empty': 'لا يوجد شيء هنا بعد.',
  'common.signOut': 'تسجيل الخروج',
  'common.administrator': 'مدير',
  'common.english': 'الإنجليزية',
  'common.arabic': 'العربية',
  'common.language': 'اللغة',
  'common.required': 'مطلوب',
  'common.optional': 'اختياري',
  'common.unnamed': 'بدون اسم',
  'common.vehicle': 'مركبة',
  'common.service': 'خدمة',
  'common.visit': 'زيارة',
  'common.booking': 'حجز',

  'nav.floor': 'اليوم',
  'nav.bookings': 'أوامر العمل',
  'nav.customers': 'العملاء',
  'nav.services': 'الخدمات',
  'nav.finances': 'المالية',
  'nav.reviews': 'التقييمات',
  'nav.resale': 'فحص ما قبل الشراء',
  'nav.mechanicActivity': 'نشاط الفريق',
  'nav.management': 'الإعدادات',

  'layout.workshop': 'الورشة',
  'layout.serviceDesk': 'مكتب الورشة',

  'login.kicker': 'الورشة',
  'login.title': 'تسجيل الدخول',
  'login.lede': 'سجّل الدخول بحساب الموظفين لفتح مكتب الخدمة.',
  'login.email': 'البريد الإلكتروني',
  'login.password': 'كلمة المرور',
  'login.submit': 'تسجيل الدخول',
  'login.submitting': 'جارٍ الدخول…',
  'login.notStaff': 'هذا المكتب لموظفي الورشة. حسابك هو ملف عميل',
  'login.loading': 'جارٍ التحميل…',

  'status.pending': 'قيد الانتظار',
  'status.confirmed': 'مؤكد',
  'status.checked_in': 'تم الاستلام',
  'status.in_progress': 'في الورشة',
  'status.completed': 'مكتمل',
  'status.cancelled': 'ملغى',

  'floor.kicker': 'مباشر',
  'floor.title': 'الورشة',
  'floor.lede': 'نظرة مباشرة على الورشة اليوم. افتح أي زيارة للمتابعة.',
  'floor.allBookings': 'كل الحجوزات',
  'floor.customers': 'العملاء',
  'floor.bookings': 'الحجوزات',
  'floor.menu': 'القائمة',
  'floor.cars': 'السيارات',
  'floor.empty': 'فارغ',
  'floor.late': 'متأخر',
  'floor.awaitingCustomer': 'بانتظار العميل',

  'bookings.kicker': 'اليومية',
  'bookings.title': 'الحجوزات',
  'bookings.lede': 'كل الزيارات في مكان واحد. صفِّ أو ابحث أو اسحب البطاقات على اللوحة.',
  'bookings.all': 'الكل',
  'bookings.today': 'اليوم',
  'bookings.upcoming': 'القادمة',
  'bookings.past': 'السابقة',
  'bookings.range': 'نطاق',
  'bookings.branch': 'الفرع',
  'bookings.file': 'ملف',
  'bookings.files': 'ملفات',
  'bookings.late': 'متأخر',
  'bookings.awaitingCustomer': 'بانتظار العميل',

  'visit.workshopSteps': 'خطوات الورشة',
  'visit.workshopLede': 'افحص أولاً، ثم سجّل القطع والعمل، ثم أرسل عرض السعر.',
  'visit.resaleTitle': 'فحص قبل الشراء',
  'visit.resaleLede': 'سجّل الاستلام، أكمل التقرير المعتمد، وانشر رابط المشتري من مكتب إعادة البيع.',
  'visit.stepInspection': 'الفحص',
  'visit.stepInspectionLede': 'العداد، الصور، التشخيص، ودرجات الحالة.',
  'visit.stepWork': 'القطع وسجل العمل',
  'visit.stepWorkLede': 'سجّل القطع والسوائل والعمل — لتغذية عرض السعر.',
  'visit.stepQuote': 'عرض السعر',
  'visit.stepQuoteLede': 'راجع الرسوم، حدّد الأسعار، ثم أرسل للعميل.',
  'visit.awaitingReply': 'بانتظار رد العميل',
  'visit.anyMechanic': 'أي ميكانيكي متاح',
  'visit.done': 'تم',
  'visit.now': 'الآن',
  'visit.next': 'التالي',
  'visit.checkInUnlock': 'سجّل استلام السيارة لفتح الفحص وسجل العمل وعرض السعر.',

  'hours.day.1': 'الاثنين',
  'hours.day.2': 'الثلاثاء',
  'hours.day.3': 'الأربعاء',
  'hours.day.4': 'الخميس',
  'hours.day.5': 'الجمعة',
  'hours.day.6': 'السبت',
  'hours.day.7': 'الأحد',

  'customers.kicker': 'الأشخاص',
  'customers.title': 'العملاء',
  'customers.lede': 'ابحث في الدليل، ثم افتح عميلاً لعرض بيانات التسجيل والمرآب والزيارات.',
  'customers.search': 'الاسم، الهاتف، البريد، اللوحة…',
  'customers.sheetSubtitle': 'التسجيل والمرآب',
  'customers.loading': 'جارٍ تحميل العملاء…',
  'customers.none': 'لا يوجد عملاء مطابقون.',
  'customers.showing': 'عرض {from}–{to} من {total}',
  'customers.clearSearch': 'مسح البحث',
  'customers.joined': 'انضم {when}',
  'customers.noCarsListed': 'لا توجد سيارات',
  'customers.colCustomer': 'العميل',
  'customers.colContact': 'التواصل',
  'customers.colGarage': 'المرآب',
  'customers.colJoined': 'الانضمام',
  'customers.pagination': 'صفحات العملاء',
  'customers.prev': 'السابق',
  'customers.next': 'التالي',
  'customers.pageOf': 'صفحة {page} من {pages}',

  'services.kicker': 'الكتالوج',
  'services.title': 'الخدمات',
  'services.lede': 'الخدمات التي يراها العملاء في التطبيق. أدخل الإنجليزية والعربية — ويعرض التطبيق لغة كل عميل.',
  'services.new': 'خدمة جديدة',
  'services.edit': 'تعديل الخدمة',
  'services.sheetSubtitle': 'قائمة الخدمات',
  'services.viewOnly': 'للعرض فقط — حساب المدير يمكنه إضافة القائمة أو تعديلها.',
  'services.noDescription': 'لا يوجد وصف',
  'services.featured': 'مميزة',
  'services.removeConfirm': 'إزالة هذه الخدمة من قائمة التطبيق؟',
  'services.remove': 'إزالة',
  'services.nameEn': 'الاسم (الإنجليزية)',
  'services.nameAr': 'الاسم (العربية)',
  'services.descriptionEn': 'الوصف (الإنجليزية)',
  'services.descriptionAr': 'الوصف (العربية)',
  'services.durationEn': 'مدة الخدمة (الإنجليزية)',
  'services.durationAr': 'مدة الخدمة (العربية)',
  'services.durationHintEn': '45 min, Half day, By quote',
  'services.durationHintAr': '٤٥ دقيقة، نصف يوم، حسب العرض',
  'services.price': 'السعر (ج.م)',
  'services.minutes': 'الدقائق التقديرية',
  'services.icon': 'الأيقونة',
  'services.sort': 'الترتيب',
  'services.visible': 'ظاهرة في التطبيق',
  'services.featuredCheck': 'مميزة في شاشة الخدمات',
  'services.langEn': 'الإنجليزية',
  'services.langAr': 'العربية',
  'services.needBothNames': 'أضف الاسم بالإنجليزية والعربية.',
  'services.needBothDescriptions': 'أضف الوصف بالإنجليزية والعربية.',
  'services.needBothDurations': 'أضف مدة الخدمة بالإنجليزية والعربية.',

  'finances.kicker': 'المالية',
  'finances.title': 'عروض الأسعار',
  'finances.lede': 'أنشئ عروض أسعار للزيارات المفتوحة، أو كعروض مستقلة للحضور المباشر.',
  'finances.create': 'إنشاء عرض سعر',

  'reviews.kicker': 'الجودة',
  'reviews.title': 'تقييمات موثّقة',
  'reviews.lede': 'يمكن للعملاء التقييم بعد زيارة مكتملة. يصل تنبيه للمديرين إذا انخفض أي تقييم عن الحد الذي تحدده.',
  'reviews.count': 'التقييمات',
  'reviews.avg': 'المتوسط العام',
  'reviews.below': 'دون الحد',
  'reviews.alerts': 'تنبيهات التقييم المنخفض',

  'resale.kicker': 'فحص معتمد قبل الشراء',
  'resale.title': 'فحوصات إعادة البيع',
  'resale.lede': 'حجوزات البائعين، مسودات الحضور، وتقارير المشتري النهائية — في مسار واحد.',
  'resale.walkIn': 'فحص حضور مباشر',
  'resale.search': 'ابحث باللوحة أو الشاصي أو البائع أو رقم التقرير',

  'alerts.kicker': 'البث',
  'alerts.title': 'التنبيهات',
  'alerts.lede': 'إشعار واحد لكل مستخدمي التطبيق — الصندوق وشاشة القفل.',
  'alerts.sent': 'مُرسل',
  'alerts.compose': 'إنشاء',
  'alerts.composeHint': 'اجعله قصيراً. هذا ما يصل إلى الهاتف.',
  'alerts.managersOnly': 'حساب المدير فقط يمكنه إرسال التنبيهات.',

  'mechanic.kicker': 'الميكانيكيون',
  'mechanic.title': 'نشاط الميكانيكي',
  'mechanic.lede': 'ابحث وصفِّ فريقك، ثم افتح ميكانيكياً لمراجعة سجل عمله بالتفصيل.',
  'mechanic.allActivity': 'كل النشاط',
  'mechanic.add': 'إضافة ميكانيكي',
  'mechanic.mechanics': 'ميكانيكيون',
  'mechanic.withActivity': 'لديهم نشاط',

  'setup.kicker': 'الإعداد',
  'setup.title': 'إعدادات الورشة',
  'setup.lede': 'اضبط الساعات والفروع والعلامات التجارية وصلاحيات الفريق — شاشة واحدة في كل مرة.',
  'setup.locations': 'الفروع',
  'setup.locationsCopy': 'الأسماء والعناوين وروابط الخريطة التي يراها العملاء في التطبيق.',
  'setup.hours': 'الساعات والحمولات',
  'setup.hoursCopy': 'أوقات العمل وطول الفترة وعدد السيارات المتزامنة.',
  'setup.brands': 'علامات السيارات',
  'setup.brandsCopy': 'الماركات والسنوات التي يمكن للعملاء إضافتها إلى المرآب.',
  'setup.team': 'الفريق',
  'setup.teamCopy': 'من يمكنه تسجيل الدخول — المديرون ومستشارو الخدمة والميكانيكيون.',
  'setup.business': 'بيانات النشاط',
  'setup.businessCopy': 'الهوية وبيانات التواصل والشعار المستخدمة في ملفات PDF وشاشات التواصل.',
  'setup.back': 'الإعداد',
  'setup.locationsLede': 'الفروع في تطبيق العميل. الساعات والحمولات في الشاشة المجاورة.',
  'setup.brandsLede': 'الماركات والسنوات التي يعرضها التطبيق عند إضافة سيارة.',
  'setup.teamLede': 'الأشخاص الذين يمكنهم فتح هذا المكتب.',
  'setup.admins': 'المديرون',
  'setup.adminsLede': 'المديرون يديرون الإعداد. مستشارو الخدمة يرون فقط تبويبات المكتب التي تمنحها لهم.',
  'setup.mechanics': 'الميكانيكيون',
  'setup.addAdmin': 'إضافة مدير',
  'setup.noAdmins': 'لا يوجد مديرون بعد.',
  'setup.noMechanics': 'لا يوجد ميكانيكيون بعد. الحجوزات تعمل بدونهم.',
  'setup.hoursLede': 'اختر فرعاً. حدّد أوقات العمل وطول الفترة وعدد السيارات المتزامنة.',
  'setup.branch': 'الفرع',
  'setup.businessTitle': 'بيانات النشاط',

  'team.name': 'الاسم',
  'team.phone': 'الهاتف',
  'team.role': 'الدور',
  'team.branch': 'الفرع',
  'team.tabs': 'التبويبات',
  'team.tabsAll': 'الكل',
  'team.tabsCount': '{n} من {total}',
  'team.unassigned': 'غير معيّن',
  'team.chooseTabs': 'اختيار التبويبات الظاهرة',
  'team.chooseTabsFor': 'اختيار التبويبات لـ {name}',
  'team.tabsTitle': 'التبويبات · {name}',
  'team.access': 'الصلاحيات',
  'team.mechanicTabsLede': 'اختر تبويبات المكتب التي يمكن لهذا الميكانيكي فتحها. تبويب واحد على الأقل مطلوب.',
  'team.advisorTabsLede': 'اختر تبويبات المكتب التي يمكن لهذا المستشار فتحها. تبويب واحد على الأقل مطلوب.',
  'team.createTabsLede': 'سيرون فقط التبويبات التي تحددها. تبويب واحد على الأقل مطلوب.',
  'team.deskTabs': 'تبويبات المكتب',
  'team.selectAll': 'تحديد الكل',
  'team.floorBookings': 'الورشة والحجوزات',
  'team.exceptSetup': 'الكل ما عدا الإعداد',
  'team.saveAccess': 'حفظ الصلاحيات',
  'team.pickOneTab': 'اختر تبويباً واحداً على الأقل.',
  'team.assignBranch': 'عيّن فرعاً أولاً.',
  'team.createLogin': 'إنشاء حساب',
  'team.creating': 'جارٍ الإنشاء…',
  'team.createLede': 'يمكنهم تسجيل الدخول بهذا البريد وكلمة المرور.',
  'team.firstName': 'الاسم الأول',
  'team.lastName': 'اسم العائلة',
  'team.email': 'البريد الإلكتروني',
  'team.tempPassword': 'كلمة مرور مؤقتة',
  'team.resetPassword': 'إعادة تعيين كلمة المرور',
  'team.resetPasswordFor': 'إعادة تعيين كلمة المرور · {name}',
  'team.newPassword': 'كلمة المرور الجديدة',
  'team.passwordHint': 'ثمانية أحرف على الأقل. سيستخدمونها في تسجيل الدخول التالي.',
  'team.resetting': 'جارٍ إعادة التعيين…',
  'team.resetOk': 'تم تحديث كلمة المرور.',
  'team.passwordMin': 'يجب أن تكون كلمة المرور ٨ أحرف على الأقل.',

  'role.manager': 'مدير',
  'role.advisor': 'مستشار خدمة',

  'reception.title': 'استقبال ذكي للمركبة',
  'reception.lede': 'تسجيل وصول رقمي: العداد، VIN، الصور، خريطة الأضرار، وتوقيع العميل.',
  'reception.complete': 'مكتمل',
  'reception.draft': 'قيد التنفيذ',
  'reception.locked': 'تم إرسال الاستقبال وهو مقفل. لا يمكن تعديله.',
  'reception.mileage': 'العداد (كم)',
  'reception.fuel': 'مستوى الوقود',
  'reception.pickFuel': 'اختر مستوى الوقود',
  'reception.fuel.empty': 'فارغ',
  'reception.fuel.1/4': 'ربع',
  'reception.fuel.1/2': 'نصف',
  'reception.fuel.3/4': 'ثلاثة أرباع',
  'reception.fuel.full': 'ممتلئ',
  'reception.vin': 'رقم الهيكل',
  'reception.vinPlaceholder': 'امسح أو اكتب رقم الهيكل',
  'reception.vinUnavailable': 'رقم الهيكل غير متوفر',
  'reception.photos': 'صور المركبة',
  'reception.photosLede': 'الأمام والخلف واليسار واليمين مطلوبة.',
  'reception.addPhoto': 'إضافة صورة',
  'reception.takePhoto': 'التقاط صورة',
  'reception.uploadPhoto': 'رفع صورة',
  'reception.side.front': 'أمام',
  'reception.side.rear': 'خلف',
  'reception.side.left': 'يسار',
  'reception.side.right': 'يمين',
  'reception.side.roof': 'سقف',
  'reception.side.interior': 'داخلية',
  'reception.bodyType': 'نوع الهيكل',
  'reception.body.sedan': 'سيدان',
  'reception.body.hatch': 'هاتشباك',
  'reception.body.suv': 'دفع رباعي',
  'reception.body.coupe': 'كوبيه',
  'reception.body.pickup': 'بيك أب',
  'reception.body.van': 'فان',
  'reception.noDamage': 'لا أضرار ظاهرة',
  'reception.tapDamage': 'انقر لتحديد الخدوش أو الصدمات',
  'reception.damageMark': 'علامة ضرر',
  'reception.clearMarks': 'مسح كل العلامات',
  'reception.undoMark': 'التراجع عن آخر علامة',
  'reception.accessories': 'الملحقات داخل السيارة',
  'reception.accessoriesPlaceholder': 'حامل هاتف، مقعد طفل… أو «لا يوجد»',
  'reception.warningLights': 'أضواء التحذير في لوحة العدادات',
  'reception.warningPlaceholder': 'لا يوجد، محرك، ABS…',
  'reception.signature': 'توقيع العميل',
  'reception.signatureLede': 'يوقّع العميل لتأكيد حالة المركبة عند التسليم.',
  'reception.signatureOnFile': 'التوقيع محفوظ.',
  'reception.captureSignature': 'التقاط التوقيع',
  'reception.resign': 'إعادة التوقيع',
  'reception.signatureReady': 'تم التقاط التوقيع',
  'reception.done': 'تم',
  'reception.clearSignature': 'مسح التوقيع',
  'reception.saveDraft': 'حفظ مسودة',
  'reception.finalize': 'إتمام الاستقبال',
  'reception.saved': 'تم حفظ مسودة الاستقبال.',
  'reception.finalized': 'تم استلام المركبة. الحجز أصبح مُسجَّل الوصول.',
  'reception.completedHint': 'الاستقبال مسجّل لهذه الزيارة.',
  'reception.start': 'بدء تسجيل الاستلام',
  'reception.continue': 'متابعة تسجيل الاستلام',
  'reception.view': 'عرض تسجيل الاستلام',
  'reception.appOnly': 'أكمل تسجيل الاستلام من تطبيق مستشار الخدمة عند وصول السيارة.',
  'reception.appOnlyTitle': 'تسجيل استلام المركبة',
  'reception.openVisit': 'فتح تسجيل الاستلام',
  'reception.checkIns': 'عمليات الاستلام',
  'reception.checkInsEmpty': 'لا توجد عمليات استلام لهذه السيارة بعد.',
  'reception.errMileage': 'أدخل قراءة العداد.',
  'reception.errFuel': 'اختر مستوى الوقود.',
  'reception.errBodyType': 'اختر نوع الهيكل.',
  'reception.errDamage': 'حدّد الضرر على الرسم أو أكّد عدم وجود ضرر.',
  'reception.errVin': 'أدخل رقم الهيكل أو علّمه غير متوفر.',
  'reception.errSignature': 'توقيع العميل مطلوب.',
  'reception.errPhoto.front': 'صورة الأمام مطلوبة.',
  'reception.errPhoto.rear': 'صورة الخلف مطلوبة.',
  'reception.errPhoto.left': 'صورة اليسار مطلوبة.',
  'reception.errPhoto.right': 'صورة اليمين مطلوبة.',
  'reception.errAuth': 'سجّل الدخول مجدداً للرفع.',
  'reception.errSave': 'تعذّر حفظ الاستقبال.',
  'role.technician': 'ميكانيكي',
  'role.customer': 'عميل',

  'icon.handyman': 'عام',
  'icon.car': 'سيارة',
  'icon.periodic': 'دورية',
  'icon.inspection': 'فحص',
  'icon.diagnostics': 'تشخيص',
  'icon.engine': 'محرك',
  'icon.oil': 'زيت',
  'icon.filter': 'فلتر',
  'icon.coolant': 'تبريد',
  'icon.fuel': 'وقود',
  'icon.battery': 'بطارية',
  'icon.electrical': 'كهرباء',
  'icon.spark': 'إشعال',
  'icon.brakes': 'فرامل',
  'icon.tyres': 'إطارات',
  'icon.alignment': 'محاذاة',
  'icon.suspension': 'تعليق',
  'icon.transmission': 'ناقل',
  'icon.clutch': 'كلتش',
  'icon.exhaust': 'عادم',
  'icon.ac': 'تكييف',
  'icon.hvac': 'مناخ',
  'icon.radiator': 'رادياتير',
  'icon.lights': 'إضاءة',
  'icon.glass': 'زجاج',
  'icon.body': 'هيكل',
  'icon.dent': 'سمكرة',
  'icon.paint': 'دهان',
  'icon.polish': 'تلميع',
  'icon.wash': 'غسيل',
  'icon.detailing': 'تفصيل',
  'icon.interior': 'داخلية',
  'icon.audio': 'صوتيات',
  'icon.keys': 'مفاتيح',
  'icon.warranty': 'ضمان',
  'icon.shield': 'تغطية',
  'icon.ev': 'كهربائية',
  'icon.charging': 'شحن',
  'icon.towing': 'قطر',
  'icon.pickup': 'استلام',
  'icon.fleet': 'أسطول',
  'icon.motorcycle': 'دراجة',
  'icon.emergency': 'طوارئ',
  'icon.quote': 'عرض سعر',
  'icon.welding': 'لحام',
  'icon.tools': 'أدوات',
  'icon.engineering': 'ورشة',
  'icon.health': 'سلامة',

  'journey.group.intake': 'الاستلام',
  'journey.group.estimate': 'التقدير',
  'journey.group.repair': 'الإصلاح',
  'journey.group.finish': 'التسليم',
  'journey.vehicle_received': 'تم استلام السيارة',
  'journey.initial_inspection': 'الفحص الأولي',
  'journey.computer_diagnosis': 'التشخيص بالكمبيوتر',
  'journey.quotation_prepared': 'تم إعداد العرض',
  'journey.awaiting_customer_approval': 'بانتظار الموافقة',
  'journey.spare_parts_requested': 'طلب قطع غيار',
  'journey.repair_in_progress': 'الإصلاح جارٍ',
  'journey.quality_inspection': 'فحص الجودة',
  'journey.car_wash': 'غسيل السيارة',
  'journey.ready_for_collection': 'جاهزة للاستلام',

  'stay.wait': 'انتظار في المركز',
  'stay.leave': 'ترك السيارة',
  'stay.pickup': 'استلام / توصيل',
  'stay.minutes': '{n} دقيقة',

  'visit.liveJourney': 'المسار الحي',
  'visit.scheduling': 'الجدولة',
  'visit.customerCar': 'العميل والسيارة',
  'visit.managedResale': 'يُدار من تبويب إعادة البيع',
  'visit.resaleOpen': 'فتح مكتب إعادة البيع',
  'visit.finalizeBefore': 'أنهِ الفحص قبل مراحل الإصلاح.',
  'visit.adminSkip': 'المدير: اضغط أي مرحلة قادمة للتخطي إليها.',
  'visit.mark': 'تأشير {name}',
  'visit.skipTo': 'تخطي إلى {name}',
  'visit.cancelVisit': 'إلغاء الزيارة',
  'visit.jumpStatus': 'الانتقال إلى حالة',
  'visit.moreStatus': 'خيارات حالة إضافية',
  'visit.nextConfirm': 'تأكيد الحجز',
  'visit.nextAssign': 'تعيين ميكانيكي',
  'visit.nextWaitingCheckIn': 'أكمل تسجيل الاستلام من تطبيق مستشار الخدمة.',
  'visit.nextWaitingHealth': 'بانتظار فحص الصحة في الورشة.',
  'visit.nextReadyBay': 'جاهز ليبدأ الميكانيكي العمل.',
  'visit.nextComplete': 'تعليم كمكتمل',
  'visit.nextStartWork': 'بدء العمل',
  'visit.pillNeedsConfirmation': 'يلزم التأكيد',
  'visit.pillNeedsCheckIn': 'يلزم الاستلام',
  'visit.pillNeedsMechanic': 'يلزم ميكانيكي',
  'visit.pillReadyBay': 'جاهز للورشة',
  'visit.pillInProgress': 'قيد التنفيذ',
  'visit.pillDone': 'مكتمل',
  'visit.pillCancelled': 'ملغى',
  'visit.detailsSubtitle': 'مرجع الزيارة',
  'visit.when': 'الموعد',
  'visit.stay': 'البقاء',
  'visit.preferredMechanic': 'الميكانيكي المفضّل',
  'visit.pickupNotes': 'ملاحظات الاستلام',
  'visit.fromCustomer': 'من العميل',
  'visit.cancelReason': 'سبب الإلغاء',
  'visit.opened': 'فُتح',
  'visit.customer': 'العميل',
  'visit.phone': 'الهاتف',
  'visit.plate': 'اللوحة',
  'visit.booked': 'محجوز',
  'visit.ready': 'جاهز',
  'visit.needHealth': 'أنهِ تقرير حالة السيارة قبل بدء العمل.',
  'visit.needReception': 'بانتظار تسجيل استلام مستشار الخدمة.',

  'bookings.list': 'قائمة',
  'bookings.kanban': 'لوحة',
  'bookings.from': 'من',
  'bookings.to': 'إلى',
  'bookings.customer': 'العميل',
  'bookings.car': 'السيارة',
  'bookings.customerPlaceholder': 'الاسم، البريد، الهاتف…',
  'bookings.carPlaceholder': 'الماركة، الموديل، السنة، اللوحة…',
  'bookings.anyStatus': 'أي حالة',
  'bookings.noPlate': 'بدون لوحة',
  'bookings.cannotMove': 'لا يمكن نقل هذا الحجز مباشرة.',
  'bookings.needHealth': 'أنهِ تقرير حالة السيارة على الحجز قبل بدء العمل.',
  'bookings.needReception': 'بانتظار تسجيل استلام مستشار الخدمة على هذا الحجز.',
  'reception.badgeDone': 'تم الاستلام',
  'reception.badgeNeeded': 'يلزم الاستلام',
  'reception.viewPhoto': 'عرض',
  'bookings.updateFailed': 'تعذّر تحديث الحجز.',
  'bookings.expand': 'توسيع {name}',
  'bookings.collapse': 'طي {name}',

  'hours.applyAll': 'تطبيق هذا الجدول على كل الفروع',
  'hours.applyAllWarn': 'الحفظ سيستبدل الساعات وطول الفترة والحمولات في كل فرع.',
  'hours.slots': 'فترات الحجز',
  'hours.slotsLede': 'طول الفترة هو شبكة اليومية. لكل فرع حمولتان كحد أقصى، لذلك لا يتداخل أكثر من عملين.',
  'hours.interval': 'الفاصل الزمني (دقائق)',
  'hours.bays': 'الحمولات المتوازية',
  'hours.opening': 'ساعات العمل',
  'hours.openingLede': 'الأيام والأوقات التي يمكن للعملاء الحجز فيها في {place}.',
  'hours.everyBranch': 'كل فرع',
  'hours.thisBranch': 'هذا الفرع',
  'hours.dayCol': 'اليوم',
  'hours.opens': 'يفتح',
  'hours.closes': 'يغلق',
  'hours.closed': 'مغلق',
  'hours.saveBranch': 'حفظ هذا الفرع',
  'hours.saveAll': 'حفظ لكل {n} فروع',

  'setup.open': 'فتح',
  'setup.saved': 'تم حفظ بيانات النشاط.',
  'setup.loadingBusiness': 'جارٍ تحميل بيانات النشاط…',
  'setup.brandName': 'اسم العلامة',
  'setup.legalName': 'الاسم القانوني',
  'setup.tagline': 'الشعار النصي',
  'setup.address': 'العنوان',
  'setup.phonePrimary': 'الهاتف الأساسي',
  'setup.phoneSecondary': 'الهاتف الثانوي',
  'setup.supportEmail': 'بريد الدعم',
  'setup.website': 'الموقع',
  'setup.logoUrl': 'رابط الشعار',
  'setup.saveBusiness': 'حفظ بيانات النشاط',
  'setup.addLocation': 'إضافة فرع',
  'setup.noLocations': 'لا توجد فروع بعد.',
  'setup.noAddress': 'بدون عنوان',
  'setup.phone': 'الهاتف',
  'setup.openMap': 'فتح الخريطة',
  'setup.setHours': 'ضبط الساعات والحمولات',
  'setup.removeLocation': 'إزالة هذا الفرع؟ الحجوزات المرتبطة تمنع الحذف.',
  'setup.editLocation': 'تعديل الفرع',
  'setup.newLocation': 'فرع جديد',
  'setup.name': 'الاسم',
  'setup.mapLink': 'رابط الخريطة',
  'setup.mapHint': 'الصق رابط المشاركة من خرائط غوغل. يضغط العملاء فتح في الخرائط في التطبيق.',
  'setup.loadFailed': 'تعذّر تحميل بيانات النشاط.',

  'assign.label': 'الميكانيكي المعيَّن',
  'assign.unassigned': 'غير معيَّن',
  'assign.empty': 'لا يوجد ميكانيكيون في هذا الفرع بعد. أضفهم من الإعدادات ← الفريق.',
  'assign.saved': 'تم حفظ تعيين الميكانيكي.',
  'assign.failed': 'تعذّر تعيين الميكانيكي.',

  'qc.title': 'فحص جودة الميكانيكي',
  'qc.approve': 'اعتماد',
  'qc.reject': 'رفض',
  'qc.waiting': 'ميكانيكي بانتظار اعتماد الجودة لهذه الزيارة.',
  'qc.approvedNote': 'مُعتمد من المكتب',
  'qc.needsWork': 'يحتاج مزيداً من العمل',

  'reschedule.title': 'إعادة جدولة الزيارة',
  'reschedule.current': 'الحالي: {when}',
  'reschedule.day': 'اليوم',
  'reschedule.loading': 'جارٍ تحميل الفترات المتاحة…',
  'reschedule.empty': 'لا توجد فترات مفتوحة في هذا اليوم.',
  'reschedule.slots': 'الفترات المتاحة',
  'reschedule.save': 'حفظ الموعد الجديد',
  'reschedule.loadFailed': 'تعذّر تحميل الفترات.',

  'quote.title': 'عرض السعر',
  'quote.titleInspection': 'عرض سعر فحص ما قبل البيع',
  'quote.titleRepair': 'عرض سعر الإصلاح',
  'quote.lede': 'سجّل القطع والعمل أولاً، ثم ابنِ العرض هنا. تُضاف بنود سجل العمل والفحص تلقائياً.',
  'quote.ledeInspection': 'حاسب البائع على الفحص المعتمد قبل الشراء. السعر من الكتالوج — عدّله قبل الإرسال.',
  'quote.ledeRepair': 'عرض اختياري للإصلاحات الموصى بها أثناء الفحص.',
  'quote.ledeClosed': 'عرض السعر لهذه الزيارة. صدّر أو شارك ملف PDF عند الحاجة.',
  'quote.ledeClosedEmpty': 'هذه الزيارة مغلقة. لم يُرسل عرض سعر.',
  'quote.emptyClosed': 'لا يوجد عرض سعر لهذه الزيارة.',
  'quote.emptyOpen': 'لم يُرسل شيء بعد.',
  'quote.replace': 'هذا يستبدل العرض الذي لدى العميل.',
  'quote.revise': 'عدّل البنود المرفوضة وأرسل مجدداً. تبدأ الموافقة من جديد.',
  'quote.item': 'البند',
  'quote.qty': 'الكمية',
  'quote.unitPrice': 'سعر الوحدة',
  'quote.line': 'السطر',
  'quote.addLine': 'إضافة بند',
  'quote.addLabour': 'إضافة عمالة',
  'quote.labour': 'عمالة',
  'quote.total': 'الإجمالي',
  'quote.workLog': 'سجل العمل',
  'quote.inspection': 'الفحص',
  'quote.sendCustomer': 'إرسال للعميل',
  'quote.sendSeller': 'إرسال للبائع',
  'quote.update': 'تحديث العرض',
  'quote.sendRevised': 'إرسال عرض معدَّل',
  'quote.syncWorkLog': 'مزامنة من سجل العمل',
  'quote.refreshCatalog': 'تحديث من الكتالوج',
  'quote.importInspection': 'استيراد من الفحص',
  'quote.notePlaceholder': 'التيل مستهلك. العمالة مشمولة.',
  'quote.itemPlaceholder': 'تيل فرامل، عمالة، زيت…',
  'quote.catalogLine': 'بند خدمة الفحص من الكتالوج — عدّل السعر إن لزم.',
  'quote.shared': 'تم مشاركة العرض.',
  'quote.downloaded': 'المشاركة غير متاحة في هذا المتصفح. تم تنزيل ملف PDF بدلاً من ذلك.',

  'worklog.kicker': 'الجواز',
  'worklog.title': 'سجل العمل',
  'worklog.lede': 'سجّل الزيت والبطارية والإطارات وقطع الغيار لهذه الزيارة. التفاصيل تظهر في جواز صيانة السيارة.',
  'worklog.opening': 'جارٍ فتح بطاقة العمل…',
  'worklog.category': 'الفئة',
  'worklog.date': 'تاريخ التركيب / الخدمة',
  'worklog.oilSpec': 'نوع الزيت / المواصفة',
  'worklog.quantity': 'الكمية',
  'worklog.unit': 'الوحدة',
  'worklog.liters': 'لتر',
  'worklog.quarts': 'كوارت',
  'worklog.event': 'العملية',
  'worklog.position': 'الموضع',
  'worklog.name': 'الاسم / القطعة',
  'worklog.partNumber': 'رقم القطعة',
  'worklog.supplier': 'المورّد',
  'worklog.serial': 'الرقم التسلسلي / الدفعة',
  'worklog.notes': 'ملاحظات',
  'worklog.add': 'إضافة إلى سجل العمل',
  'worklog.added': 'أُضيف إلى سجل العمل.',
  'worklog.photo': 'إضافة صورة العبوة',
  'worklog.uploading': 'جارٍ الرفع…',
  'worklog.photoAttached': 'تم إرفاق صورة',
  'worklog.cat.oil': 'زيت وفلتر',
  'worklog.cat.battery': 'بطارية',
  'worklog.cat.tire': 'إطارات',
  'worklog.cat.spare': 'قطعة غيار',
  'worklog.cat.other': 'أخرى',
  'worklog.event.replace': 'استبدال',
  'worklog.event.rotate': 'تدوير',
  'worklog.event.top_up': 'تعبئة',
  'worklog.event.inspect': 'فحص',
  'worklog.pos.FL': 'أمامي أيسر',
  'worklog.pos.FR': 'أمامي أيمن',
  'worklog.pos.RL': 'خلفي أيسر',
  'worklog.pos.RR': 'خلفي أيمن',
  'worklog.pos.all': 'كل الإطارات',

  'health.title': 'فحص حالة السيارة',
  'health.ledeOpen': 'ابدأ من بيانات السيارة المحفوظة، اضغط الاقتراحات للتعبئة أسرع، ثم أنهِ الفحص قبل الدخول إلى الورشة.',
  'health.ledeDone': 'تم إرسال الفحص. راجع الدرجات، صدّر PDF، أو عدّل إن لزم.',
  'health.loading': 'جارٍ تحميل فحص الحالة…',
  'health.afterCheckin': 'فحص الحالة متاح بعد استلام السيارة.',
  'health.savedMileage': 'العداد المحفوظ',
  'health.notSet': 'غير محدّد بعد',
  'health.progress': '{n} من 5 بنود مطلوبة مكتملة',
  'health.ready': 'جاهز',
  'health.required': 'مطلوب',
  'health.mileage': 'العداد الحالي',
  'health.mileageHelp': 'مُعبأ مسبقاً من مرآب العميل. حدّثه إذا كانت قراءة العداد أعلى.',
  'health.odometer': 'العداد (كم)',
  'health.useSaved': 'استخدام المحفوظ {n} كم',
  'health.services': 'خدمات حديثة / مستحقة',
  'health.diagnostics': 'التشخيص',
  'health.accident': 'سجل الحوادث',
  'health.photos': 'صور',
  'health.scores': 'درجات الحالة',
  'health.finalize': 'إنهاء',
  'health.finalizeTitle': 'إنهاء تقرير الحالة؟',
  'health.finalized': 'تم إنهاء تقرير الحالة.',
  'health.draftSaved': 'تم حفظ المسودة.',
  'health.good': 'جيد',
  'health.fair': 'مقبول',
  'health.poor': 'ضعيف',
  'health.goodHint': 'لا توجد مشاكل',
  'health.fairHint': 'راقب / اخدمة قريباً',
  'health.poorHint': 'يحتاج اهتماماً',
  'health.overall': 'الإجمالي',

  'customer.overview': 'نظرة عامة',
  'customer.health': 'الحالة',
  'customer.passport': 'الجواز',
  'customer.engine': 'المحرك',
  'customer.transmission': 'ناقل الحركة',
  'customer.mileage': 'العداد',
  'customer.vin': 'رقم الشاصي',
  'customer.warranty': 'الضمان',
  'customer.insurance': 'التأمين',
  'customer.open': 'فتح',
  'customer.noVisitsCar': 'لا زيارات لهذه السيارة بعد.',
  'customer.noVisits': 'لا زيارات بعد.',
  'customer.latestInspection': 'آخر فحص',
  'customer.earlierReports': 'تقارير سابقة',
  'customer.noHealth': 'لا يوجد تقرير حالة منتهٍ بعد.',
  'customer.noInspection': 'لا فحص بعد',
  'customer.lastChecked': 'آخر فحص {when}',
  'customer.download': 'تنزيل',
  'customer.share': 'مشاركة',
  'customer.preparing': 'جارٍ التحضير…',
  'customer.noPhone': 'لا يوجد هاتف',
  'customer.noPlate': 'بدون لوحة',
  'customer.cars': 'السيارات',
  'customer.visits': 'الزيارات',
  'customer.registration': 'التسجيل',
  'customer.registrationLede': 'البيانات التي أُدخلت عند إنشاء الحساب.',
  'customer.garage': 'المرآب والزيارات',
  'customer.garageLede': 'السيارات المسجلة وكل زيارات الخدمة المرتبطة بهذا العميل.',
  'customer.firstName': 'الاسم الأول',
  'customer.lastName': 'اسم العائلة',
  'customer.email': 'البريد',
  'customer.phone': 'الهاتف',
  'customer.memberSince': 'عضو منذ',
  'customer.role': 'الدور',
  'customer.call': 'اتصال',
  'customer.emailAction': 'بريد',
  'customer.loading': 'جارٍ تحميل العميل…',
  'customer.noCars': 'لا توجد سيارات على هذا الحساب بعد.',
  'customer.carOne': 'سيارة',
  'customer.carsCount': 'سيارات',
  'customer.visitOne': 'زيارة',
  'customer.visitsCount': 'زيارات',

  'finances.connect': 'ربط بزيارة مفتوحة',
  'finances.modeBooking': 'زيارة مفتوحة',
  'finances.modeStandalone': 'حضور / بلا زيارة',
  'finances.searchPlaceholder': 'الهاتف، البريد، العميل، اللوحة…',
  'finances.bookingDate': 'تاريخ الحجز',
  'finances.bookingCount': '{n} زيارات مفتوحة · الأحدث أولاً',
  'finances.bookingCountOne': 'زيارة مفتوحة واحدة · الأحدث أولاً',
  'finances.noMatch': 'لا توجد زيارات مفتوحة مطابقة. جرّب هاتفاً أو بريداً أو تاريخاً آخر.',
  'finances.selected': 'المحدد: {service} في {when}',
  'finances.created': 'تم إنشاء العرض وإرساله للعميل.',
  'finances.createdStandalone': 'تم إنشاء العرض. انشر رابطاً لمشاركته.',
  'finances.exported': 'تم تصدير عرض PDF.',
  'finances.shared': 'تم مشاركة العرض.',
  'finances.sharedFallback': 'المشاركة غير متاحة هنا. تم تنزيل PDF بدلاً من ذلك.',
  'finances.needLines': 'كل بند يحتاج كمية لا تقل عن 1 وسعراً صالحاً.',
  'finances.needOneLine': 'أضف بنداً واحداً على الأقل.',
  'finances.needBooking': 'اختر زيارة مفتوحة أولاً.',
  'finances.standaloneCustomer': 'العميل (اختياري)',
  'finances.standaloneHint': 'اربط حساب عميل، أو اتركه فارغاً لعرض تقدير حضور مباشر.',
  'finances.customerSearch': 'ابحث عن العميل بالاسم أو الهاتف أو البريد…',
  'finances.clearCustomer': 'مسح',
  'finances.noCustomerOk': 'لم يُختر عميل — يمكنك إنشاء العرض ومشاركته.',
  'finances.vehicleLabel': 'السيارة (اختياري)',
  'finances.vehicleLabelPlaceholder': 'مثلاً BMW 320i · ABC 1234',
  'finances.standaloneBadge': 'مستقل',
  'finances.noCustomer': 'بدون عميل',
  'finances.listSearch': 'ابحث بالعميل أو الخدمة أو اللوحة…',
  'finances.allStatuses': 'كل الحالات',
  'finances.statusSent': 'بانتظار الرد',
  'finances.statusApproved': 'معتمد',
  'finances.statusPartial': 'جزئي',
  'finances.statusRejected': 'مرفوض',
  'finances.statusDraft': 'مسودة',
  'finances.loading': 'جارٍ تحميل العروض…',
  'finances.none': 'لا توجد عروض في هذا العرض.',
  'finances.colQuote': 'العرض',
  'finances.colCustomer': 'العميل',
  'finances.colStatus': 'الحالة',
  'finances.colTotal': 'الإجمالي',
  'finances.linkLive': 'رابط نشط',
  'finances.pagination': 'صفحات العروض',
  'finances.createSubtitle': 'زيارة مفتوحة أو تقدير حضور',
  'finances.sending': 'جارٍ الإرسال…',
  'finances.createdAt': 'تاريخ الإنشاء',
  'finances.visit': 'الزيارة',
  'finances.openVisit': 'فتح الزيارة',

  'reviews.notify': 'أبلغ المديرين عندما يكون أي بُعد عند المستوى المحدد أو دونه (1 = صارم، 5 = متوقف).',
  'reviews.threshold': 'تنبيه عندما يكون أي تقييم عند أو دون',
  'reviews.sendAlerts': 'إرسال تنبيهات للمديرين',
  'reviews.verified': 'موثّق',
  'reviews.lowScore': 'تقييم منخفض',
  'reviews.overall': 'الإجمالي',
  'reviews.advisor': 'المستشار',
  'reviews.mechanic': 'الميكانيكي',
  'reviews.speed': 'السرعة',
  'reviews.price': 'وضوح السعر',
  'reviews.cleanliness': 'النظافة',
  'reviews.pickup': 'الاستلام والتوصيل',

  'alerts.needEnglish': 'العنوان والرسالة بالإنجليزية مطلوبان.',
  'alerts.sentOk': 'أُرسل. الهواتف التي فعّلت الإشعارات ستستلم التنبيه.',
  'alerts.titleLabel': 'العنوان',
  'alerts.message': 'الرسالة',
  'alerts.arabicTitle': 'العنوان بالعربية',
  'alerts.arabicMessage': 'الرسالة بالعربية',
  'alerts.optional': 'اختياري',
  'alerts.previewTitle': 'العنوان',
  'alerts.previewBody': 'الرسالة التي سيراها العملاء.',

  'resale.emptyPending': 'لا فحوصات واردة.',
  'resale.emptyConfirmed': 'لا فحوصات مؤكدة بعد.',
  'resale.deleteDraft': 'تعذّر حذف المسودة.',

  'common.poweredBy': 'مدعوم من',
  'common.export': 'تصدير',
  'common.share': 'مشاركة',
  'common.open': 'فتح',
  'common.remove': 'إزالة',
  'common.create': 'إنشاء',
  'common.all': 'الكل',
};

export const messages = {
  en: { ...en, ...workshopEn },
  ar: { ...ar, ...workshopAr },
};

export function currentLocale() {
  if (typeof document === 'undefined') return 'en';
  return document.documentElement.lang === 'ar' ? 'ar' : 'en';
}

export function interpolate(template, vars = {}) {
  return String(template).replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] == null ? '' : String(vars[key]),
  );
}

export function translate(key, vars) {
  const table = messages[currentLocale()] || messages.en;
  const raw = table[key] ?? messages.en[key] ?? key;
  return vars ? interpolate(raw, vars) : raw;
}
